import { render } from "./Relocation.vue?vue&type=template&id=632cad96&scoped=true"
import script from "./Relocation.vue?vue&type=script&lang=js"
export * from "./Relocation.vue?vue&type=script&lang=js"

import "./Relocation.vue?vue&type=style&index=0&id=632cad96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-632cad96"]])

export default __exports__